<div class="container mx-auto px-0 py-0">
  <div class="bg-white shadow-md rounded-lg p-6">
    
    <!-- Header -->
    <div class="flex justify-between items-center mb-6">
      <div class="flex items-center space-x-2">
        <h2 class="text-2xl font-bold mb-0 text-red-600">
          🗑️ {{ 'STATUS_VIEW.GELOESCHT_TITLE' | translate }}
        </h2>
      </div>
    </div>

    <!-- Status Description -->
    <div class="mb-6 p-4 bg-red-50 border-l-4 border-red-400 rounded">
      <div class="flex">
        <div class="flex-shrink-0">
          <mat-icon class="text-red-400">delete</mat-icon>
        </div>
        <div class="ml-3">
          <p class="text-sm text-red-700">
            {{ 'STATUS_VIEW.GELOESCHT_RESTORE_HINT' | translate }}
          </p>
        </div>
      </div>
    </div>

    <!-- Header Info Section -->
    <app-header-info 
      [kontrolltermin]="kontrolltermin" 
      [editableFields]="[]"
      [showTimeFields]="true"
      [sourceStatus]="'geloescht'">
    </app-header-info>

    <app-techniker-infos [standort]="kontrolltermin.standort"></app-techniker-infos>

    <!-- Actions Section -->
    <div class="flex justify-between items-center pt-6 border-t border-gray-200">
      <div class="flex space-x-3">
        <button 
          mat-raised-button 
          color="primary" 
          (click)="restoreKontrolltermin()"
          [disabled]="isSaving || !canRestore()"
          class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm font-medium">
          <mat-icon class="mr-2">restore</mat-icon>
          {{ 'STATUS_VIEW.RESTORE' | translate }}
        </button>
        
        <button 
          mat-button 
          (click)="onCancel()"
          class="bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-md text-sm font-medium">
          <mat-icon class="mr-2">close</mat-icon>
          {{ 'COMMON.CLOSE' | translate }}
        </button>
      </div>
      
      <!-- Info message for past dates -->
      <div *ngIf="!canRestore()" class="flex items-center text-amber-600">
        <mat-icon class="mr-2 text-sm">info</mat-icon>
        <span class="text-sm">{{ 'STATUS_VIEW.CANNOT_RESTORE_PAST' | translate }}</span>
      </div>
    </div>
  </div>
</div>
